import { Component, OnInit, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from 'src/app/guards/pending-changes.guard';
import { MeetingRecordComponent } from 'src/app/components/main/shared/meeting-record/meeting-record.component';

@Component({
  selector: 'app-job-vacancy-candidate-meeting-record-detail',
  templateUrl: './job-vacancy-candidate-meeting-record-detail.component.html',
  styleUrls: [
    './job-vacancy-candidate-meeting-record-detail.component.css',
    '../../../shared/meeting-record/meeting-record-parent-shell.styles.css',
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MeetingRecordComponent],
})
export class JobCandidateMeetingRecordDetailComponent implements OnInit, ComponentCanDeactivate {
  private readonly activated_route = inject(ActivatedRoute);

  @ViewChild(MeetingRecordComponent) child_component: MeetingRecordComponent;

  meetingableType: 'App\\Models\\JobVacancyCandidatePhaseProgress' = 'App\\Models\\JobVacancyCandidatePhaseProgress';
  meetingableId = 0;
  meetingRecordId = 0;
  job_vacancy_id = 0;
  job_candidate_id = 0;

  ngOnInit(): void {
    this.job_vacancy_id = Number(this.activated_route.snapshot.paramMap.get('job_vacancy_id'));
    this.job_candidate_id = Number(this.activated_route.snapshot.paramMap.get('id'));

    const meeting_record_id_param = this.activated_route.snapshot.paramMap.get('meeting_record_id');
    this.meetingRecordId = meeting_record_id_param === null || meeting_record_id_param === 'new' ? 0 : Number(meeting_record_id_param);
  }

  candidateDetailRouterLink(): string {
    return `/employees/rrhh/job-vacancies/${this.job_vacancy_id}/candidates/${this.job_candidate_id}`;
  }

  canDeactivate(): Observable<boolean> | boolean {
    return this.child_component.canDeactivate();
  }
}
